<!-- 推荐药品 -->
<template>
  <div class="card">
    <div class="cardBody">
      <div class="re-medicine-card">
        <!-- 标题区域 -->
        <div class="header">
          <div class="title">为您推荐以下调理方案</div>
          <div class="subtitle">推荐依据：{{ msg.textContent }}</div>
        </div>

        <!-- 药品列表 -->
        <div class="medicine-list">
          <div class="medicine-item" v-for="(item, index) in medicineData" :key="index">
            <div class="medicine-img">
              <img class="img" :src="item.imageUrl" />
            </div>
            <div class="medicine-info">
              <div class="medicine-header">
                <div class="medicine-tag" v-if="item.skuType && typeEnum[item.skuType]">
                  {{ typeEnum[item.skuType] }}
                </div>
                <div class="medicine-name">{{ item.skuName }}</div>
              </div>
              <ComPrice
                :price="item.price"
                :priceUnitStyle="{ fontSize: '12px', color: '#f84f4f', fontWeight: '500' }"
                :priceIntegerStyle="{ fontSize: '16px', color: '#f84f4f', fontWeight: '500' }"
                :priceDecimalStyle="{ fontSize: '12px', color: '#f84f4f', fontWeight: '500' }"
              ></ComPrice>
            </div>
          </div>
        </div>
        <!-- 申请购买按钮 -->
        <!-- <div class="action-btn" v-if="msg && msg.status == 0">
      <a-button type="primary" disabled :style="btnStyle">申请购买</a-button>
    </div> -->
        <!-- AI生成标识 -->
        <div class="ai-tag">内容由AI生成</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue'
import ComPrice from '@/components/cus-price'

const props = defineProps({
  msg: {
    type: Object,
    default: () => ({})
  }
})
const typeEnum = {
  1: '西/中成药',
  3: '协定方',
  4: '健康用品',
  5: '西/中成药',
  7: '协定方'
}

// const btnStyle = {
//   backgroundColor: '#4c6ee0',
//   color: '#ffffff',
//   borderRadius: '20px',
//   height: '40px',
//   fontSize: '14px',
//   width: '100%'
// }

const medicineData = computed(() => {
  const { prescriptionRecommendJsonStr = '' } = props.msg || {}
  return props?.msg?.prescriptionRecommendJsonStr ? JSON.parse(prescriptionRecommendJsonStr) : {}
})
</script>

<style scoped lang="scss">
.card {
  display: flex;
  justify-content: center;
  .cardBody {
    width: 432px;
    .re-medicine-card {
      padding: 10px 14px 12px 14px;
      border-radius: 8px;
      background: #fff;

      .header {
        margin-bottom: 10px;

        .title {
          font-weight: 500;
          font-size: 14px;
          color: #333333;
          margin-bottom: 2px;
        }

        .subtitle {
          font-weight: 400;
          font-size: 12px;
          color: #999999;
        }
      }

      .medicine-list {
        border-radius: 8px;
        background: #f2f5fa;
        padding: 12px 14px;
        .medicine-item {
          display: flex;
          align-items: flex-start;
          margin-bottom: 16px;

          &:last-child {
            margin-bottom: 0;
          }

          .medicine-img {
            width: 92px;
            height: 92px;
            border-radius: 8px;
            background: #ffffff;
            border: 1px solid #eeeeee;
            margin-right: 12px;
            flex-shrink: 0;
            overflow: hidden;

            .img {
              width: 100%;
              height: 100%;
            }
          }

          .medicine-info {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            min-height: 70px;
            margin-top: 4px;

            .medicine-header {
              display: flex;
              align-items: flex-start;
              margin-bottom: 16px;

              .medicine-tag {
                flex-shrink: 0;
                padding: 2px 6px;
                border-radius: 4px;
                background: #dfe9f2;
                font-size: 11px;
                color: #465469;
                margin-right: 6px;
              }

              .medicine-name {
                flex: 1;
                font-weight: 500;
                font-size: 16px;
                color: #1a1a1a;
                line-height: 1.4;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
              }
            }
          }
        }
      }

      .action-btn {
        margin-top: 12px;
      }

      .ai-tag {
        font-weight: 400;
        font-size: 10px;
        color: #b2b2b2;
        margin-top: 12px;
      }
    }
  }
}
</style>
